// src/components/admin/adminsidebar/AdminSidebar.jsx
import React from 'react';
import {
  FiGrid, FiUsers, FiShoppingBag, FiShoppingCart, FiUser,
  FiAlertCircle, FiDollarSign, FiUserPlus, FiLogOut,
  FiTag, FiMessageSquare, FiFileText, FiMonitor, FiImage,
  FiClipboard, FiHelpCircle, FiSettings, FiX
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/admin/components/adminsidebar/AdminSidebar.css';

const AdminSidebar = ({ isCollapsed, isMobileOpen, onCloseMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { label: 'Dashboard',              icon: <FiGrid />,         path: '/admin/dashboard' },
    { label: 'SubAdmins',              icon: <FiUserPlus />,     path: '/admin/subadmins' },
    { label: 'Shops Management',       icon: <FiShoppingBag />,  path: '/admin/shops' },
    { label: 'Category Management',    icon: <FiTag />,          path: '/admin/categories' },
    { label: 'Products Management',    icon: <FiShoppingCart />, path: '/admin/products' },
    { label: 'Orders Management',      icon: <FiClipboard />,    path: '/admin/orders' },
    { label: 'Support Tickets',        icon: <FiMessageSquare />,path: '/admin/tickets' },
    { label: 'Blog Management',        icon: <FiFileText />,     path: '/admin/blogs' },
    { label: 'Marquee Management',     icon: <FiMonitor />,      path: '/admin/marquee' },
    { label: 'Hero Section Management',icon: <FiImage />,        path: '/admin/hero-section' },
    { label: 'Topup Management',               icon: <FiDollarSign />,   path: '/admin/earnings' },
    { label: 'FAQ Management',         icon: <FiHelpCircle />,   path: '/admin/faq' },
    { label: 'Settings',               icon: <FiSettings />,     path: '/admin/settings' },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    if (onCloseMobile) onCloseMobile();
  };

  return (
    <>
      {isMobileOpen && (
        <div className="admin-sidebar-overlay" onClick={onCloseMobile} />
      )}

      <aside
        className={`admin-sidebar${isCollapsed ? ' collapsed' : ''}${
          isMobileOpen ? ' mobile-open' : ''
        }`}
      >
        <div className="admin-sidebar-profile">
          <div className="admin-sidebar-profile-text">
            <h3>CRAFTHIVE</h3>
            <span>Admin Panel</span>
          </div>
          <button
            className="admin-sidebar-close-btn"
            onClick={onCloseMobile}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        </div>

        <nav className="admin-sidebar-menu">
          {menu.map(item => (
            <button
              key={item.path}
              className={`admin-sidebar-menu-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavigate(item.path)}
              data-label={item.label}
              title={isCollapsed ? item.label : ''}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        {/* <button
          className="admin-sidebar-logout"
          onClick={() => handleNavigate('/admin/logout')}
        >
          <FiLogOut />
          <span>Logout</span>
        </button> */}
      </aside>
    </>
  );
};

export default AdminSidebar;